<agr-page-detail
  [pageTitle]="pageTitle$ | async"
  data-test="departure-item__page-detail"
  (backAction)="back()"
>
  <section
    class="departure-item spacing--padding-all spacing--margin-all"
    data-test="departure-item"
  >
    <form
      [formGroup]="departureForm"
      [agrConnectForm]="departureNotNull$"
      (ngSubmit)="save()"
      *ngIf="cycle$ | async as cycle"
    >
      <div class="flex--column">
        <mat-form-field class="flex__child--auto">
          <mat-label>{{ 'departure-item.date' | translate }}</mat-label>
          <input
            formControlName="departureDate"
            matInput
            [matDatepicker]="departureDatePicker"
            placeholder="{{ 'departure-item.date' | translate }}"
            [value]=""
            [min]="minArrivalDate$ | async"
            [max]="maxArrivalDate"
            data-test="departure-item__departure-date"
          />
          <mat-datepicker-toggle matIconSuffix [for]="departureDatePicker"></mat-datepicker-toggle>
          <mat-datepicker touchUi #departureDatePicker></mat-datepicker>
          <mat-error *ngIf="departureForm.controls.departureDate.invalid">
            {{ 'departure-item.error-date' | translate }}
          </mat-error>
        </mat-form-field>

        <mat-form-field class="flex__child--auto">
          <mat-label>{{ 'departure-item.barn' | translate }}</mat-label>
          <mat-select
            [hideSingleSelectionIndicator]="true"
            [compareWith]="compareBarns"
            formControlName="barn"
            data-test="departure-item__barn"
          >
            <mat-option *ngFor="let barn of barns$ | async" [value]="barn">
              {{ barn.name }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="departureForm.controls.barn.invalid">
            {{ 'departure-item.error-barn' | translate }}
          </mat-error>
        </mat-form-field>

        <mat-form-field class="flex__child--auto" *ngIf="departureForm.controls['barn'].value">
          <mat-label>{{ 'departure-item.type' | translate }}</mat-label>
          <mat-select
            [hideSingleSelectionIndicator]="true"
            formControlName="type"
            data-test="departure-item__type"
          >
            <mat-option value="Full">
              {{ 'departure-item.type-full' | translate }}
            </mat-option>
            <mat-option value="Partial">
              {{ 'departure-item.type-partial' | translate }}
            </mat-option>
          </mat-select>
          <mat-error
            *ngIf="
              !!departureForm.controls.type.errors && departureForm.controls.type.errors.required
            "
          >
            {{ 'departure-item.error-type' | translate }}
          </mat-error>
        </mat-form-field>

        <mat-form-field class="flex__child--auto" *ngIf="departureForm.controls['barn'].value">
          <mat-label>{{ 'departure-item.amount-of-chicks' | translate }}</mat-label>
          <input
            matInput
            agrNumber
            [enableStepArrows]="false"
            formControlName="amountOfChicks"
            placeholder="{{ 'departure-item.amount-of-chicks' | translate }}"
            data-test="departure-item__amount-of-chicks"
          />
          <span matTextSuffix class="form-field-suffix">
            {{ 'departure-item.chicks' | translate | lowercase }}
          </span>
          <mat-error
            *ngIf="
              !!departureForm.controls.amountOfChicks.errors &&
              departureForm.controls.amountOfChicks.errors.min
            "
          >
            {{ 'departure-item.error-amount-of-chicks-min' | translate }}
          </mat-error>
          <mat-error
            *ngIf="
              !!departureForm.controls.amountOfChicks.errors &&
              departureForm.controls.amountOfChicks.errors.maxAmount
            "
          >
            <ng-container *ngIf="departureForm.controls.amountOfChicks.errors.maxAmount !== true">
              {{ 'departure-item.error-amount-of-chicks-max' | translate }}
              {{ departureForm.controls.amountOfChicks.errors.maxAmount }}
            </ng-container>
            <ng-container *ngIf="departureForm.controls.amountOfChicks.errors.maxAmount === true">
              {{ 'departure-item.error-no-chicks-remaining' | translate }}
            </ng-container>
          </mat-error>
          <mat-error
            *ngIf="
              !!departureForm.controls.amountOfChicks.errors &&
              departureForm.controls.amountOfChicks.errors.required
            "
          >
            {{ 'departure-item.error-amount-of-chicks-required' | translate }}
          </mat-error>
        </mat-form-field>
        <!-------------------------------------------S L A U G H T E R   R E S U L T S -->
        <div class="text--h5 departure-item__subtitle">
          {{ 'departure-item.slaughter-results' | translate }}
        </div>
        <mat-slide-toggle
          [hideIcon]="true"
          data-test="departure-item__toggleAmounts"
          color="primary"
          class="text--small spacing--padding-right"
          labelPosition="before"
          formControlName="amounts"
        >
          {{ 'enter-amounts' | translate }}
        </mat-slide-toggle>
        <div class="flex--column">
          <mat-form-field class="flex__child--auto">
            <mat-label>{{ 'departure-item.slaughterhouse' | translate }}</mat-label>
            <mat-select
              [hideSingleSelectionIndicator]="true"
              [compareWith]="compareSlaughterhouses"
              formControlName="slaughterhouse"
              data-test="departure-item__slaughterhouse"
            >
              <mat-option
                *ngFor="let slaughterhouse of slaughterhouses$ | async"
                [value]="slaughterhouse"
              >
                {{ slaughterhouse.name }} - {{ slaughterhouse.address }} - {{ slaughterhouse.city }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div class="flex--row flex--gutter">
            <mat-form-field
              class="flex__child--auto"
              [ngClass]="{
                'mat-form-field-invalid':
                  departureForm.errors?.slaughterWeightHigherThanDepartureWeight,
              }"
            >
              <mat-label>{{ 'departure-item.weight' | translate }}</mat-label>
              <input
                matInput
                agrNumber
                [enableStepArrows]="false"
                formControlName="departureWeight"
                placeholder="{{ 'departure-item.weight' | translate }}"
                [step]="0.01"
                data-test="departure-item__weight"
              />
              <span matTextSuffix class="form-field-suffix">kg</span>
            </mat-form-field>
            <mat-form-field class="flex__child--auto">
              <mat-label>{{ 'departure-item.rejection-at-slaughterhouse' | translate }}</mat-label>
              <input
                matInput
                agrNumber
                [enableStepArrows]="false"
                formControlName="rejectionAtSlaughterhouseInKg"
                placeholder="{{ 'departure-item.rejection-at-slaughterhouse' | translate }}"
                [step]="0.01"
                data-test="departure-item__rejection-at-slaughterhouse"
              />
              <span matTextSuffix class="form-field-suffix">kg</span>
            </mat-form-field>
            <mat-form-field class="flex__child--auto">
              <mat-label>{{ 'departure-item.rejection-during-transport' | translate }}</mat-label>
              <input
                matInput
                agrNumber
                [step]="0.01"
                [enableStepArrows]="false"
                formControlName="rejectionDuringTransportInKg"
                placeholder="{{ 'departure-item.rejection-during-transport' | translate }}"
                data-test="departure-item__rejection-during-transport"
              />
              <span matTextSuffix class="form-field-suffix">kg</span>
            </mat-form-field>
          </div>
          <div class="flex--row flex--gutter">
            <mat-form-field
              class="flex__child--auto"
              [ngClass]="{
                'mat-form-field-invalid':
                  departureForm.errors?.slaughterWeightHigherThanDepartureWeight,
              }"
            >
              <mat-label>{{ 'departure-item.slaughter-weight' | translate }}</mat-label>
              <input
                matInput
                agrNumber
                [enableStepArrows]="false"
                formControlName="slaughterWeight"
                placeholder="{{ 'departure-item.slaughter-weight' | translate }}"
                [step]="0.01"
                data-test="departure-item__slaughter-weight"
              />
              <span matTextSuffix class="form-field-suffix">kg</span>
            </mat-form-field>
            <mat-form-field class="flex__child--auto" *ngIf="departureForm.controls.amounts.value">
              <mat-label>{{ 'departure-item.revenueSubTotal' | translate }}</mat-label>
              <span matTextPrefix agrNumber class="spacing--padding-half-right">{{
                cycle.currency | agrCurrencySymbol
              }}</span>
              <input
                matInput
                agrNumber
                [step]="0.0001"
                [enableStepArrows]="false"
                data-test="departure-item__revenueSubTotal"
                formControlName="revenueSubTotal"
                placeholder="{{ 'departure-item.revenueSubTotal' | translate }}"
              />
            </mat-form-field>
          </div>
          <div class="flex--row flex--gutter">
            <mat-form-field class="flex__child--auto" *ngIf="departureForm.controls.amounts.value">
              <mat-label>{{ 'departure-item.diverseCosts' | translate }}</mat-label>
              <span matTextPrefix agrNumber class="spacing--padding-half-right">{{
                cycle.currency | agrCurrencySymbol
              }}</span>
              <input
                matInput
                agrNumber
                [step]="0.0001"
                [enableStepArrows]="false"
                data-test="departure-item__diverseCosts"
                formControlName="diverseCosts"
                placeholder="{{ 'departure-item.diverseCosts' | translate }}"
              />
            </mat-form-field>
            <mat-form-field class="flex__child--auto" *ngIf="departureForm.controls.amounts.value">
              <mat-label>{{ 'departure-item.revenue' | translate }}</mat-label>
              <span matTextPrefix agrNumber class="spacing--padding-half-right">{{
                cycle.currency | agrCurrencySymbol
              }}</span>
              <input
                matInput
                agrNumber
                [step]="0.0001"
                [enableStepArrows]="false"
                data-test="departure-item__revenue"
                formControlName="revenue"
                placeholder="{{ 'departure-item.revenue' | translate }}"
              />
            </mat-form-field>
          </div>

          <div
            class="flex--row flex--gutter"
            *ngIf="!(departure$ | async)?.linkedSlaughterReportId"
          >
            <mat-form-field class="flex__child--auto" *ngIf="isFinalSetup">
              <mat-label>{{ 'invoice-date' | translate }}</mat-label>
              <input
                matInput
                formControlName="invoiceDate"
                [matDatepicker]="invoiceDatePicker"
                placeholder="{{ 'invoice-date' | translate }}"
                data-test="departure-item__invoice-date"
              />
              <mat-datepicker-toggle
                matIconSuffix
                [for]="invoiceDatePicker"
              ></mat-datepicker-toggle>
              <mat-datepicker touchUi #invoiceDatePicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field class="flex__child--auto" *ngIf="isFinalSetup">
              <mat-label>{{ 'invoice-number' | translate }}</mat-label>
              <input
                matInput
                formControlName="invoiceNumber"
                placeholder="{{ 'invoice-number' | translate }}"
                data-test="departure-item__invoice-number"
              />
            </mat-form-field>

            <mat-form-field class="flex__child--auto" *ngIf="isFinalSetup">
              <mat-label>{{ 'vat-percentage' | translate }}</mat-label>
              <span matTextSuffix class="form-field-suffix">%</span>
              <mat-select
                [hideSingleSelectionIndicator]="true"
                formControlName="vatPercentage"
                data-test="discount-item__vatPercentage"
              >
                <mat-option [value]="null"></mat-option>
                <mat-option *ngFor="let vatPercentage of vatPercentages" [value]="vatPercentage">
                  {{ vatPercentage }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div
            data-test="departure-item__weight-validation"
            *ngIf="
              departureForm.errors?.slaughterWeightHigherThanDepartureWeight &&
              (departureForm.touched || departureForm.dirty)
            "
            class="notification notification-error"
          >
            <mat-icon>error</mat-icon>
            {{ 'departure-item.weight-validation' | translate }}
          </div>

          <mat-form-field class="flex__child--auto">
            <mat-label>{{ 'departure-item.heel-dermatitis' | translate }}</mat-label>
            <input
              matInput
              agrNumber
              [step]="0.01"
              [enableStepArrows]="false"
              formControlName="heelDermatitis"
              placeholder="{{ 'departure-item.heel-dermatitis' | translate }}"
              data-test="departure-item__heel-dermatitis"
            />
          </mat-form-field>
          <div class="flex--row flex--gutter">
            <mat-form-field class="flex__child--auto">
              <mat-label>{{ 'departure-item.footpad-lesion-score' | translate }}</mat-label>
              <input
                matInput
                agrNumber
                [step]="0.01"
                [enableStepArrows]="false"
                formControlName="footpadLesionScore"
                placeholder="{{ 'departure-item.footpad-lesion-score' | translate }}"
                data-test="departure-item__footpad-lesion-score"
              />
            </mat-form-field>
            <mat-form-field class="flex__child--auto">
              <mat-label>{{ 'departure-item.footpad-lesion-none' | translate }}</mat-label>
              <input
                matInput
                agrNumber
                [step]="0.01"
                [enableStepArrows]="false"
                formControlName="footpadLesionNonePercentage"
                placeholder="{{ 'departure-item.footpad-lesion-none' | translate }}"
                data-test="departure-item__footpad-lesion-none"
              />
              <span matTextSuffix class="form-field-suffix">%</span>
            </mat-form-field>
            <mat-form-field
              class="flex__child--auto"
              [ngClass]="{ 'mat-form-field-invalid': departureForm.errors?.mustBe100percent }"
            >
              <mat-label>{{ 'departure-item.footpad-lesion-moderate' | translate }}</mat-label>
              <input
                matInput
                agrNumber
                [step]="0.01"
                [enableStepArrows]="false"
                formControlName="footpadLesionModeratePercentage"
                placeholder="{{ 'departure-item.footpad-lesion-moderate' | translate }}"
                data-test="departure-item__footpad-lesion-moderate"
              />
              <span matTextSuffix class="form-field-suffix">%</span>
            </mat-form-field>
            <mat-form-field
              class="flex__child--auto"
              [ngClass]="{ 'mat-form-field-invalid': departureForm.errors?.mustBe100percent }"
            >
              <mat-label>{{ 'departure-item.footpad-lesion-severe' | translate }}</mat-label>
              <input
                matInput
                agrNumber
                [step]="0.01"
                [enableStepArrows]="false"
                formControlName="footpadLesionSeverePercentage"
                placeholder="{{ 'departure-item.footpad-lesion-severe' | translate }}"
                data-test="departure-item__footpad-lesion-severe"
              />
              <span matTextSuffix class="form-field-suffix">%</span>
            </mat-form-field>
          </div>
        </div>

        <div
          data-test="departure-item__footpad-lesion-scores-validation"
          *ngIf="
            departureForm.errors?.mustBe100percent && (departureForm.touched || departureForm.dirty)
          "
          class="notification notification-error"
        >
          <mat-icon>error</mat-icon>
          {{ 'departure-item.footpad-lesion-validation' | translate }}
        </div>

        <div
          class="mat-button-row spacing--margin-top"
          *ngIf="!(departure$ | async)?.linkedSlaughterReportId"
        >
          <button type="submit" mat-flat-button color="primary">
            {{ 'save' | translate }}
          </button>
        </div>
      </div>
    </form>
  </section>
</agr-page-detail>
